export default __webpack_public_path__ + "images/215f4afb65751b64d052cf0b94189ff6-github.svg";